var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAnalyzeLite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30.636,
    height: 30.624,
    fill: "none",
    viewBox: "0 0 30.636 30.624",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.436 21.712v2.6211c0 2.8204-2.2101 5.0911-4.9553 5.0911h-18.325c-2.7453 0-4.9554-2.2707-4.9554-5.0911v-2.6211",
    stroke: "#8895b5",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.436 8.9122v-2.6211c0-2.8205-2.2101-5.0911-4.9553-5.0911h-18.325c-2.7453 0-4.9554 2.2706-4.9554 5.0911v2.6211",
    stroke: "#8895b5",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.9985 20.268 2.1898-4.159m3.3514-0.67391 3.9492 2.5394m3.0964-0.85605 2.2507-5.9744",
    stroke: "#585858"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#585858",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.8493 24.643c1.1476-0.405 1.7533-1.6565 1.3529-2.7952s-1.6552-1.7335-2.8028-1.3284c-1.1476 0.405-1.7533 1.6565-1.3529 2.7952 0.40038 1.1387 1.6552 1.7335 2.8028 1.3284z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.116 16.003c1.1476-0.405 1.7533-1.6565 1.3529-2.7952s-1.6552-1.7335-2.8028-1.3284c-1.1476 0.405-1.7533 1.6565-1.3529 2.7952 0.40039 1.1387 1.6553 1.7335 2.8028 1.3284z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.181 21.475c1.1475-0.4051 1.7532-1.6566 1.3529-2.7953-0.4004-1.1387-1.6553-1.7334-2.8029-1.3284-1.1475 0.4051-1.7533 1.6565-1.3529 2.7952s1.6553 1.7335 2.8029 1.3285z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.326 10.91c1.1475-0.405 1.7532-1.6565 1.3529-2.7952-0.4004-1.1387-1.6553-1.7335-2.8029-1.3284-1.1475 0.40505-1.7533 1.6565-1.3529 2.7952s1.6553 1.7335 2.8029 1.3284z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnalyzeLite);
export default __webpack_public_path__ + "static/media/icon_analyze_lite.f3b9061fbf165d4db5afa3ed94c24f82.svg";
export { ForwardRef as ReactComponent };